import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { auth, db } from "../services/firebase";

export default function useFetchAllPurchases() {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const user = auth.currentUser;
        if (!user) {
            setHistory([]);
            setLoading(false);
            return;
        }

        const uid = user.uid;
        const purchasesRef = ref(db, `Payments/Purchases/${uid}`);

        const unsubscribe = onValue(purchasesRef, (snapshot) => {
            const data = snapshot.val() || {};
            const list = [];

            const now = Date.now();

            Object.entries(data).forEach(([domainId, packs]) => {
                Object.entries(packs).forEach(([packId, pack]) => {
                    const expiresAt = pack.expiresAt || null;
                    const expired = expiresAt ? now > expiresAt : false;

                    list.push({
                        domainId,
                        packId,
                        expired,
                        active: !expired,
                        ...pack,
                    });
                });
            });

            // Sort by newest first
            list.sort((a, b) => b.createdAt - a.createdAt);

            setHistory(list);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return { history, loading };
}
